module.exports = __webpack_public_path__ + "assets/img/rxs1.01b9adec.png";